import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { announcementsAPI } from '../services/api';

interface AnnouncementModalProps {
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const AnnouncementModal: React.FC<AnnouncementModalProps> = ({ visible, onHide, onSuccess }) => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    
    if (!title.trim()) {
      setError('Naslov je obavezan');
      return;
    }
    
    if (!message.trim()) {
      setError('Poruka je obavezna');
      return;
    }

    setLoading(true);
    try {
      await announcementsAPI.create({
        title: title.trim(),
        message: message.trim()
      });
      setTitle('');
      setMessage('');
      onSuccess();
      onHide();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Greška pri kreiranju obaveštenja');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setTitle('');
    setMessage('');
    setError('');
    onHide();
  };

  return (
    <Dialog
      header="Novo obaveštenje"
      visible={visible}
      style={{ width: '500px' }}
      onHide={handleClose}
      footer={
        <div>
          <Button 
            label="Otkaži" 
            icon="pi pi-times" 
            onClick={handleClose} 
            className="p-button-text" 
            disabled={loading}
          />
          <Button 
            label="Pošalji" 
            icon="pi pi-send" 
            onClick={handleSubmit} 
            loading={loading}
          />
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {error && (
          <div style={{ padding: '0.75rem', backgroundColor: '#fee2e2', color: '#991b1b', borderRadius: '4px', fontSize: '0.875rem' }}>
            {error}
          </div>
        )}
        
        <div>
          <label htmlFor="title" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
            Naslov <span style={{ color: '#dc2626' }}>*</span>
          </label>
          <InputText
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Unesite naslov obaveštenja"
            style={{ width: '100%' }}
            maxLength={200}
          />
        </div>

        <div>
          <label htmlFor="message" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
            Poruka <span style={{ color: '#dc2626' }}>*</span>
          </label>
          <InputTextarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Unesite poruku obaveštenja"
            rows={5}
            style={{ width: '100%' }}
            maxLength={5000}
          />
        </div>

        <div style={{ 
          padding: '0.75rem', 
          backgroundColor: '#f3f4f6', 
          borderRadius: '4px', 
          fontSize: '0.875rem',
          color: '#6b7280'
        }}>
          Ovo obaveštenje biće prikazano svim zaposlenima kao celoprostorni popup dok ga ne potvrde.
        </div>
      </div>
    </Dialog>
  );
};

export default AnnouncementModal;



